import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import {
  getRespuestaTexto,
  getRespuestaIcono,
  QUESTION_TYPES
} from '../../utils/encuestas'
import css from './ModalDetallesEncuesta.module.css'

const RespuestaFace = ({ item }) => {
  return (
    <div className={css.respuesta} data-type='face'>
      <div className={css.opciones}>
        {item.opciones.map((opcion, idx) => (
          <div
            key={idx}
            data-status={item.respuesta === opcion ? 'selected' : 'unselected'}
            className={css.opcion}
          >
            <i
              className={`material-icons ${css.sentiment}`}
              data-sentiment={getRespuestaIcono(opcion)}
            >
              {getRespuestaIcono(opcion)}
            </i>
            <span className={css.label}>{getRespuestaTexto(opcion)}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

const RespuestaText = ({ item }) => {
  return (
    <div className={css.respuesta} data-type='text'>
      {item.respuesta ? (
        <p className={css.text}>{item.respuesta}</p>
      ) : (
        <span className={css.empty}>Sin respuesta</span>
      )}
    </div>
  )
}

const RespuestaMultipleChoice = ({ item }) => {
  const respuestas = item.respuesta
    ? item.respuesta
        .split('.')
        .map(r => r.trim())
        .filter(r => r.length > 0)
    : []
  return (
    <div className={css.respuesta} data-type='multiple-choice'>
      {respuestas.length > 0 ? (
        <div className={css.multipleChoiceGrid}>
          {item.opciones.map((opcion, idx) => {
            const isSelected = respuestas.includes(opcion)
            return (
              <div
                key={idx}
                className={css.multipleChoiceOption}
                data-selected={isSelected}
              >
                <i className={`material-icons ${css.checkIcon}`}>
                  {isSelected ? 'check_box' : 'check_box_outline_blank'}
                </i>
                <span className={css.multipleChoiceLabel}>{opcion}</span>
              </div>
            )
          })}
        </div>
      ) : (
        <span className={css.empty}>Sin respuesta</span>
      )}
    </div>
  )
}

const RespuestaSlider = ({ item }) => {
  const selectedValue = item.respuesta
  return (
    <div className={css.respuesta} data-type='slider'>
      {selectedValue !== null && selectedValue !== undefined ? (
        <div className={css.sliderContainer}>
          <div className={css.sliderTrack}>
            {item.opciones.map((opcion, idx) => {
              const isSelected =
                opcion === selectedValue ||
                String(opcion) === String(selectedValue)
              return (
                <div
                  key={idx}
                  className={css.sliderPoint}
                  data-selected={isSelected}
                >
                  <div className={css.sliderDot}></div>
                  <span className={css.sliderValue}>{opcion}</span>
                </div>
              )
            })}
          </div>
        </div>
      ) : (
        <span className={css.empty}>Sin respuesta</span>
      )}
    </div>
  )
}

const RespuestaGeneral = ({ item }) => {
  if (item.tipo === QUESTION_TYPES.FACE) return <RespuestaFace item={item} />
  if (item.tipo === QUESTION_TYPES.TEXT) return <RespuestaText item={item} />
  if (item.tipo === QUESTION_TYPES.MULTIPLE_CHOICE)
    return <RespuestaMultipleChoice item={item} />
  if (item.tipo === QUESTION_TYPES.SLIDER)
    return <RespuestaSlider item={item} />
  return null
}

const ModalDetallesEncuesta = ({ open, encuesta, onClose }) => {
  if (!encuesta) return null
  const hasProfesores = encuesta.profesores && encuesta.profesores.length > 0

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle className={css.title}>
        Respuestas de {encuesta.alumno.nombre}
      </DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          <div className={css.info}>
            <div className={css.infoItem}>
              <strong>Academia:</strong>
              <span>{encuesta.centro}</span>
            </div>
            <div className={css.infoItem}>
              <strong>Profesores:</strong>
              {hasProfesores ? (
                <div className={css.chips}>
                  {encuesta.profesores.map((profesor, index) => (
                    <Chip
                      color='primary'
                      key={index}
                      label={profesor.nombre}
                      size='small'
                    />
                  ))}
                </div>
              ) : (
                <span className={css.placeholder}>
                  Sin profesores evaluados
                </span>
              )}
            </div>
          </div>
        </DialogContentText>
        <div className={css.cuestionario}>
          {encuesta.cuestionario?.map((item, index) => (
            <div key={index} className={css.pregunta}>
              <div className={css.preguntaHeader}>
                <span className={css.preguntaTexto}>{item.pregunta}</span>
                {item.opcional && <Chip label='Opcional' size='small' />}
              </div>
              <RespuestaGeneral item={item} />
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalDetallesEncuesta
